import { ReactComponent as CrossIcon } from 'assets/icon/x-white.svg';
import { useAppSelector, useAppDispatch } from 'hooks/useAppDispatchSelector';
import { setPreviewFileData } from 'store/features/modelSlice';
import { initFileData } from 'helpers/utils';

const FileViewer = () => {
  const dispatch = useAppDispatch();
  const { fileData } = useAppSelector(state => state.modal);
  const { type, content } = fileData;
  const getFileContent = () => {
    switch (type) {
      case 'image':
        return (
          <img src={content?.url} className="h-[calc(100vh-7rem)] w-auto  object-contain" alt="" />
        );
        case "video":
          return <video controls src={content.url} autoPlay></video>
      default:
        return <iframe src={content?.url} title="doc" className="h-[calc(100vh-4rem)] w-full" />;
    }
  };
  const handleClosePreview = () => {
    dispatch(setPreviewFileData(initFileData));
  };
  return type ? (
    <>
      <div className="modal-backdrop fixed top-0 left-0 right-0 bottom-0 z-50 "></div>
      {/*Main modal*/}
      <div
        id="common-modal"
        aria-hidden="true"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        className="modal fixed top-0 left-0 right-0 z-50 w-full overflow-x-hidden overflow-y-auto h-full JAYMIN"
      >
        <div className="flex items-center justify-end p-4 cursor-pointer">
          <CrossIcon color="#ffff" height={24} width={24} onClick={() => handleClosePreview()} />
        </div>
        <div className="modal-dialog relative w-full flex mx-auto max-w-4xl max-h-[calc(100%-3.5rem)] ">
          {/*Modal content*/}
          <div className="modal-content relative w-full flex flex-col rounded-2xl overflow-hidden max-h-full">
            {/*Modal body*/}
            <div className="modal-body bg-transparent overflow-y-auto">
              <div className="flex items-center justify-center">{getFileContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default FileViewer;
